import { gql } from "@apollo/client";
import { ORDER_FRAGMENT } from "order/fragments/order";

import { TICKET_WITH_RELATIONS_FRAGMENT } from "./fragments/ticketWithRelations";

export const TICKET_UPDATE_MUTATION = gql`
  ${TICKET_WITH_RELATIONS_FRAGMENT}
  ${ORDER_FRAGMENT}
  mutation TicketUpdate(
    $id: Int!
    $input: TicketUpdateInput!
    $ticketPoolInclude: Boolean = false
    $eventInclude: Boolean = false
    $fileInclude: Boolean = false
    $orderInclude: Boolean = false
  ) {
    ticketUpdate(id: $id, input: $input) {
      ...TicketWithRelations
    }
  }
`;

export const TICKET_SCAN_MUTATION = gql`
  ${TICKET_WITH_RELATIONS_FRAGMENT}
  ${ORDER_FRAGMENT}
  mutation TicketScan(
    $data: String
    $eventOccurrenceId: String
    $ticketPoolInclude: Boolean = false
    $eventInclude: Boolean = false
    $fileInclude: Boolean = false
    $orderInclude: Boolean = false
  ) {
    ticketScan(data: $data, eventOccurrenceId: $eventOccurrenceId) {
      ...TicketWithRelations
    }
  }
`;

export const TICKET_SCAN_BY_ORDER_ID_MUTATION = gql`
  mutation TicketScanByOrderId($orderId: Int!, $eventOccurrenceId: String!) {
    ticketScanByOrderId(
      orderId: $orderId
      eventOccurrenceId: $eventOccurrenceId
    )
  }
`;
